// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { foundry as _foundry } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the foundry chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 31337
 * Chain Name: Foundry
 * Default Block Explorer: Not specified
 * Default RPC URL: http://127.0.0.1:8545
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { foundry } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: foundry,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const foundry = createCommon({
	..._foundry,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
